export default __webpack_public_path__ + "static/media/B0006.256e40e6.png";